import { msalInstance } from '../auth/msalConfig';

export class MsalUtils {
  private static initializationPromise: Promise<void> | null = null;
  private static isInitialized = false;

  static async ensureInitialized(): Promise<void> {
    if (this.isInitialized) {
      return;
    }

    if (!this.initializationPromise) {
      this.initializationPromise = this.initialize();
    }

    return this.initializationPromise;
  }

  private static async initialize(): Promise<void> {
    try {
      await msalInstance.initialize();
      await msalInstance.handleRedirectPromise();
      this.isInitialized = true;
    } catch (error) {
      console.error('MSAL initialization failed:', error);
      this.isInitialized = true;
      throw error;
    }
  }

  static async getAllAccounts() {
    await this.ensureInitialized();
    return msalInstance.getAllAccounts();
  }

  static async acquireTokenSilent(request: any) {
    await this.ensureInitialized();
    return msalInstance.acquireTokenSilent(request);
  }

  static async clearCache() {
    await this.ensureInitialized();
    return msalInstance.clearCache();
  }

  static isReady(): boolean {
    return this.isInitialized;
  }

  static resetInitialization(): void {
    this.initializationPromise = null;
    this.isInitialized = false;
  }
}
